export const loadImage = (url: string): Promise<HTMLImageElement> => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const setImageURL = async () => {
      const imageBlob = await (await fetch(url, { method: 'GET', cache: 'no-cache' })).blob();
      image.src = URL.createObjectURL(imageBlob);
    };

    const image = new Image();

    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', () => reject(new Error(`Failed to load image: ${url}`)));

    setImageURL();
  });
};
